var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskScenario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 36,
    stroke: "#929292",
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5603V20.6697M21 27.7792H21.018M18.5041 4.48096L3.67859 29.7314C2.85627 31.1319 2.44512 31.8322 2.50589 32.4069C2.55889 32.9082 2.82525 33.3638 3.23867 33.6602C3.71265 34 4.53327 34 6.17451 34H35.8255C37.4667 34 38.2873 34 38.7613 33.6602C39.1748 33.3638 39.4411 32.9082 39.4941 32.4069C39.5549 31.8322 39.1437 31.1319 38.3214 29.7314L23.4959 4.48095C22.6765 3.08543 22.2669 2.38767 21.7324 2.15332C21.2661 1.94889 20.7339 1.94889 20.2676 2.15332C19.7331 2.38767 19.3235 3.08543 18.5041 4.48096Z",
    strokeWidth: 3.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskScenario);
export default __webpack_public_path__ + "static/media/risk-scenario.537bc2b36a8758d30f899ba4472fd1c4.svg";
export { ForwardRef as ReactComponent };